var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"view",rawName:"v-view",value:(_vm.viewHandler),expression:"viewHandler"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }